import type { WorkflowStatusId } from 'types/workflow/workflow-status';

const STORAGE_KEY = 'funner_recent_chats_v1';
const MAX_ENTRIES = 20;

export type RecentChatEntry = {
  /** נתיב מלא לניווט (pathname + search) */
  to: string;
  /** תצוגה — שם או מספר */
  label: string;
  /** מזהה לקוח בשיחה (מספר טלפון בנתיב) */
  chatUserId: string;
  /** צילום סטטוס Flow בעת הביקור (כשהמשתמש לא טעון ברשימות) */
  flowStatusCode?: WorkflowStatusId | null;
  at: number;
};

function safeParse(raw: string | null): RecentChatEntry[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is RecentChatEntry => {
      if (typeof x !== 'object' || x === null) return false;
      const e = x as RecentChatEntry;
      if (
        typeof e.to !== 'string' ||
        typeof e.label !== 'string' ||
        typeof e.chatUserId !== 'string' ||
        typeof e.at !== 'number'
      ) {
        return false;
      }
      if (e.flowStatusCode != null) {
        const c = e.flowStatusCode;
        if (typeof c !== 'number' || c < 1 || c > 6) return false;
      }
      return true;
    });
  } catch {
    return [];
  }
}

export function loadRecentChats(): RecentChatEntry[] {
  if (typeof window === 'undefined') return [];
  return safeParse(localStorage.getItem(STORAGE_KEY));
}

function save(entries: RecentChatEntry[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    // ignore quota / private mode
  }
}

/** רישום או קידום שיחה לראש הרשימה — דה-דופ לפי chatUserId */
export function recordRecentChat(entry: {
  to: string;
  label: string;
  chatUserId: string;
  flowStatusCode?: WorkflowStatusId | null;
}): void {
  const at = Date.now();
  const list = loadRecentChats();
  const next = [{ ...entry, at }, ...list.filter((x) => x.chatUserId !== entry.chatUserId)].slice(0, MAX_ENTRIES);
  save(next);
}
